import { jsx as m } from "react/jsx-runtime";
import { forwardRef as x, useMemo as d, useRef as E, useImperativeHandle as g, useEffect as B } from "react";
import i from "./index.es729.js";
import L from "classnames";
import { BoxState as O } from "./index.es524.js";
import { BoxContextProvider as w } from "./index.es520.js";
const b = x(
  (u, c) => {
    const { as: f, className: l, highlightOnHover: r, externalBoxState: s, ...v } = u, t = d(() => s ?? new O(), [s]), o = E(null), h = f ?? "div";
    g(c, () => o.current, []), B(() => {
      function n() {
        t.hovered.set(!0);
      }
      function a() {
        t.hovered.set(!1);
      }
      const e = o.current;
      return r && (e == null || e.addEventListener("mouseenter", n), e == null || e.addEventListener("mouseleave", a)), () => {
        e == null || e.removeEventListener("mouseenter", n), e == null || e.removeEventListener("mouseleave", a);
      };
    }, [r, t]);
    const p = L(i.container, l, {
      [i.highlightOnHover]: r
    });
    return /* @__PURE__ */ m(w, { boxState: t, children: /* @__PURE__ */ m(h, { ref: o, ...v, className: p }) });
  }
);
export {
  b as Box
};
//# sourceMappingURL=index.es519.js.map
